import { render, staticRenderFns } from "./insurance_detail.vue?vue&type=template&id=5364425c&scoped=true&"
import script from "./insurance_detail.vue?vue&type=script&lang=js&"
export * from "./insurance_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364425c",
  null
  
)

export default component.exports